/**
 * Idézet megjelenítő komponenes
 *
 * @author Erik Banhalmi 2017.06.12.
 */

const MODULE_NAME = 'quoteDisplayer';

class QuoteDisplayerController {
	constructor() {
		'ngInject';
	}
	$onInit() {}

	$onChanges(changeObject) {
		if (!changeObject.qoutation.isFirstChange()) {
			this.quote = angular.copy(this.qoutation);
		}
	}
}

export default angular.module(MODULE_NAME, []).component('quoteDisplayer', {
	transclude: true,
	controller: QuoteDisplayerController,
	templateUrl: 'quote-displayer.html',
	bindings: {
		qoutation: '<'
	}
}).name;
